var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiBob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    rx: 1,
    fill: "#E42C51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4253 28.3161C22.7831 28.3161 21.4526 26.9865 21.4526 25.3502C21.4526 23.7138 22.7831 22.3843 24.4253 22.3843C26.0675 22.3843 27.3979 23.7138 27.3979 25.3502C27.3979 26.9865 26.0675 28.3161 24.4253 28.3161ZM24.4253 23.3252C23.3027 23.3252 22.3881 24.2456 22.3881 25.3502C22.3881 26.4752 23.3027 27.3752 24.4253 27.3752C25.5478 27.3752 26.4625 26.4752 26.4625 25.3502C26.4625 24.2252 25.5478 23.3252 24.4253 23.3252Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.861 22.7523V20.175C15.861 19.8068 15.5492 19.5 15.175 19.5C14.8216 19.5 14.5098 19.8068 14.5098 20.175V25.35C14.5098 27.0886 15.9441 28.5 17.6903 28.5C19.4572 28.5 20.8708 27.0886 20.8708 25.3295C20.8708 23.5909 19.4365 22.1591 17.6903 22.1591C17.0043 22.1795 16.3807 22.3841 15.861 22.7523ZM17.6903 27.15C16.6717 27.15 15.861 26.3318 15.861 25.3295C15.861 24.3273 16.6925 23.5091 17.6903 23.5091C18.7089 23.5091 19.5196 24.3273 19.5196 25.3295C19.5404 26.3318 18.7089 27.15 17.6903 27.15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7242 22.6089C29.7888 22.6089 28.9781 23.0589 28.4792 23.7543V19.868C28.4792 19.7248 28.3544 19.6021 28.2297 19.6021C28.0842 19.6021 27.9595 19.7248 27.9595 19.868V25.3498C27.9595 26.8634 29.2067 28.0907 30.7242 28.0907C32.2625 28.0907 33.489 26.8634 33.489 25.3293C33.5098 23.8361 32.2625 22.6089 30.7242 22.6089ZM30.7242 27.5998C29.477 27.5998 28.4792 26.5975 28.4792 25.3702C28.4792 24.143 29.4978 23.1407 30.7242 23.1407C31.9715 23.1407 32.9693 24.143 32.9693 25.3702C32.9901 26.5771 31.9715 27.5998 30.7242 27.5998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiBob);
export default __webpack_public_path__ + "static/media/HiBob.f405bae7b8c1fb54211045ff867b53f0.svg";
export { ForwardRef as ReactComponent };